import { useIntl } from 'react-intl'
import { KTIcon } from '../../../../helpers'
import { SidebarMenuItem } from './SidebarMenuItem'
import { SidebarMenuItemWithSub } from './SidebarMenuItemWithSub';

const TCGATE_DOCS_URL = import.meta.env.VITE_TCGATE_DOCS_URL;
const TCGATE_HELP_EMAIL = import.meta.env.VITE_TCGATE_HELP_EMAIL ?? "info@trendcommerce.ch";

const SidebarMenuMain = () => {
  const intl = useIntl()

  return (
    <>
      <SidebarMenuItem
        to='/dashboard'
        icon='chart-pie-3'
        title={intl.formatMessage({ id: 'MENU.DASHBOARD' })}
        fontIcon='bi-app-indicator'
      />

      {/* --- Documents --- */}
      <SidebarMenuItemWithSub
        to='/documents'
        icon='file'
        title={intl.formatMessage({ id: 'MENU.DOCUMENTS' })}
      >
        {/* All Documents */}
        <SidebarMenuItem
          to='/documents/all'
          hasBullet
          title={intl.formatMessage({ id: 'MENU.DOCUMENTS', defaultMessage: 'All Documents' })}
        />
        {/* Bounced Documents */}
        <SidebarMenuItem
          to='/documents/bounced'
          hasBullet
          title={intl.formatMessage({ id: 'MENU.BOUNCED_DOCUMENTS', defaultMessage: 'Bounced Documents' })}
        />

      </SidebarMenuItemWithSub>
      {/* --- end Documents --- */}

      <SidebarMenuItem
        to='/orders'
        icon='rocket'
        title={intl.formatMessage({ id: 'MENU.ORDERS' })}
      />
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>{intl.formatMessage({ id: 'MENU.HELP' })}</span>
        </div>
      </div>
      <div className='menu-item'>
        <a
          target='_blank'
          rel='noopener noreferrer'
          className='menu-link'
          href={`mailto:${TCGATE_HELP_EMAIL}`}
        >
          <span className='menu-icon'>
            <KTIcon iconName='element-plus' className='fs-2' />
          </span>
          <span className='menu-title'>{intl.formatMessage({ id: 'MENU.SUPPORT' })}</span>
        </a>
      </div>

      <div className='menu-item'>
        <a
          target='_blank'
          rel='noopener noreferrer'
          className='menu-link'
          href={TCGATE_DOCS_URL}
        >
          <span className='menu-icon'>
            <KTIcon iconName='abstract-26' className='fs-2' />
          </span>
          <span className='menu-title'>{intl.formatMessage({ id: 'MENU.DOCUMENTATION' })}
          </span>
        </a>
      </div>
      <SidebarMenuItem
        to='/status'
        icon='code'
        title={intl.formatMessage({ id: 'MENU.SYSTEM_STATUS' })}
      />
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>{intl.formatMessage({ id: 'MENU.SETTINGS' })}</span>
        </div>
      </div>
      <SidebarMenuItem
        to='/profile'
        icon='profile-circle'
        title={intl.formatMessage({ id: 'MENU.PROFILE' })}
        fontIcon='bi-layers'
      />

    </>
  )
}

export { SidebarMenuMain }
